import { createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  FormDecoratorBlueprint,
  createScaffolderFormDecorator,
} from '@backstage/plugin-scaffolder-react/alpha';
import { oidcAuthApiRef } from '../auth';

/*
 * Phase 4: inject the signed-in user's Keycloak access token into every scaffolder task
 * as the secret `kcToken`. The `onboarding:submit` backend action reads ctx.secrets.kcToken
 * and forwards it as the bearer to the onboarding API (which validates a KC-issued JWT and
 * enforces `project-requester`). A form decorator is the sanctioned new-frontend-system way
 * to "collect secrets from the user before submitting to the backend" - no visible field,
 * and the token never lands in the manifest or on disk.
 *
 * Same token source as the 4b-0 admin page (oidcAuthApiRef.getAccessToken()). Setting the
 * secret on all scaffolder runs is harmless: it is the user's own token, sent only to actions
 * that read it.
 */
const kcTokenDecorator = createScaffolderFormDecorator({
  id: 'onboarding:kcToken',
  deps: { oidc: oidcAuthApiRef },
  async decorator(ctx, { oidc }) {
    const kcToken = await oidc.getAccessToken();
    ctx.setSecrets(current => ({ ...current, kcToken }));
  },
});

const kcTokenDecoratorExtension = FormDecoratorBlueprint.make({
  name: 'onboarding-kc-token',
  params: { decorator: kcTokenDecorator },
});

export const onboardingWizardModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [kcTokenDecoratorExtension],
});

export default onboardingWizardModule;
